import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Auth model: the backend issues a single `session_token` httpOnly cookie
 * on /auth/login (and /auth/2fa/verify). We send `withCredentials: true`
 * on every request so the browser attaches that cookie automatically.
 *
 * No JWT lives in localStorage anymore — that defeats httpOnly's whole
 * point (XSS-stolen tokens). The migration helper below removes any
 * legacy token written by older builds so users don't keep a stale copy.
 */
try {
  if (typeof window !== "undefined" && window.localStorage?.getItem("token")) {
    window.localStorage.removeItem("token");
  }
} catch (_) {
  // localStorage may throw in some sandboxed iframes — ignore
}

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err),
);
